import { Avatar, AvatarSize } from '@eventbrite/eds-avatar';
import React from 'react';
import { useOrganizerBasicInfo } from '../../../../../contexts/OrganizerContext';
import DefaultImageVariants from '../../DefaultImageVariants/DefaultImageVariants';
import { testIds } from './constants';
import styles from './ListingsAvatarBadge.module.scss';
import type { IListingsAvatarProps } from './types';

const AVATAR_SIZE_MAP = {
    [AvatarSize.xxsmall]: 24,
    [AvatarSize.xsmall]: 32,
    [AvatarSize.small]: 50,
    [AvatarSize.medium]: 76,
    [AvatarSize.large]: 100,
};

export const ListingsAvatar: React.FC<IListingsAvatarProps> = ({
    featureFlags,
    size = AvatarSize.xxsmall,
}) => {
    const enableCreatorDefaultAvatar =
        featureFlags?.enableCreatorDefaultAvatar || false;
    const { avatar, id } = useOrganizerBasicInfo();

    const defaultAvatarJSX =
        (enableCreatorDefaultAvatar && (
            <div
                className={styles.avatarImage}
                style={{
                    width: `${AVATAR_SIZE_MAP[size]}px`,
                    height: `${AVATAR_SIZE_MAP[size]}px`,
                }}
                data-testid={testIds.defaultAvatar}
            >
                <DefaultImageVariants organizerId={id} />
            </div>
        )) ||
        null;

    return avatar ? <Avatar imageUrl={avatar} size={size} /> : defaultAvatarJSX;
};
